// Dependencies
import React, { useState, useRef, useEffect } from 'react';
import Preferences from 'Core/containers/Preferences'
import { showLandmarksOnMap,showGeofencesOnMap,showPreventOverlapLabels,showUnitLabels,showUnitCluster } from 'Components/Map/utils'


/*********************************************************
 * actions
 *********************************************************/
import {  loadObjectsLandmarksOnMap, loadObjectsGeofenceOnMap } from "Redux/actions";

/*********************************************************
 * Utils
 *********************************************************/
import { convertStringToIntegerBoolean } from 'Core/data/Helpers';
import { normalizeUnitLabelSelect } from 'Components/Map/utils';

const PreferenceLoad = (props) => {

    /********************************************************
 * Define const
 ********************************************************/
    const { mapRef } = props
    const keyPreferences = "mapSettings"
    const preferencesRef = useRef()
    const [mapSettingsVars, setMapSettingsVars] = useState({})
    const [preferencesLoaded, setPreferencesLoaded] = useState(false)
    const defaultSlideValue = 10;

    /*********************************************************
* Load the default values from preferences for first time
*********************************************************/
    const loadPreferencesDefault = (preferences) => {
        if (preferences) {
            let mapSettingsPreferences = { ...mapSettingsVars };
            
            // Check if new properties already exist
            const hasNewProperties = preferences.hasOwnProperty('labelSelect_unit') || preferences.hasOwnProperty('labelSelect_driver');
            
            Object.keys(preferences)?.forEach((key) => {
                let value = preferences[key];
                
                // Handle legacy unitLabelSelect ONLY if new properties don't exist
                if (key === 'unitLabelSelect' && !hasNewProperties) {
                    const normalized = normalizeUnitLabelSelect(value);
                    mapSettingsPreferences['labelSelect_unit'] = normalized.label;
                    mapSettingsPreferences['labelSelect_driver'] = normalized.driver;
                } else if (key === 'unitLabelSelect' && hasNewProperties) {
                    // Skip legacy unitLabelSelect if new properties exist
                    return;
                } else {
                    // Handle other preferences including labelSelect_unit and labelSelect_driver
                    value = convertStringToIntegerBoolean(value);
                    if (typeof value !== "boolean" && !isNaN(value) && value < 4) {
                        mapSettingsPreferences = { ...mapSettingsPreferences, [key]: Boolean(value) }
                    } else {
                        if (typeof value === 'string') {
                            mapSettingsPreferences = { ...mapSettingsPreferences, [key]: value }
                        } else {
                            mapSettingsPreferences = { ...mapSettingsPreferences, [key]: isNaN(value) ? false : value }
                        }
                    }
                }
            })

            // Only set defaults if properties don't exist after processing
            if (mapSettingsPreferences['labelSelect_unit'] === undefined) {
                mapSettingsPreferences['labelSelect_unit'] = false;
            }
            if (mapSettingsPreferences['labelSelect_driver'] === undefined) {
                mapSettingsPreferences['labelSelect_driver'] = false;
            }

            // Update unitLabelShow based on individual flags
            mapSettingsPreferences['unitLabelShow'] = Boolean(
                mapSettingsPreferences['labelSelect_unit'] || mapSettingsPreferences['labelSelect_driver']
            );

            // Build unitLabelSelect object for map functions
            const unitLabelSelectForMap = {
                label: Boolean(mapSettingsPreferences['labelSelect_unit'] ?? false),
                driver: Boolean(mapSettingsPreferences['labelSelect_driver'] ?? false)
            };

            showUnitCluster(mapSettingsPreferences,mapRef)
            setMapSettingsVars(mapSettingsPreferences)
            showLandmarksOnMap(mapRef,loadObjectsLandmarksOnMap,mapSettingsPreferences,defaultSlideValue)
            showGeofencesOnMap(mapSettingsPreferences,defaultSlideValue,mapRef,loadObjectsGeofenceOnMap)
            showUnitLabels({ ...mapSettingsPreferences, unitLabelSelect: unitLabelSelectForMap },mapRef)
            showPreventOverlapLabels(mapSettingsPreferences,mapRef)

            // Mark preferences as loaded to trigger effect
            setPreferencesLoaded(true);
        }
    }

    // Effect to execute after preferences are loaded and state is updated
    useEffect(() => {
        if (preferencesLoaded && mapRef?.current?.showUnitsByPreferences) {
            mapRef.current.showUnitsByPreferences();
            setPreferencesLoaded(false); // Reset flag
        }
    }, [preferencesLoaded, mapRef]);
    

    return (
        <Preferences
            ref={preferencesRef}
            preferencesKey={keyPreferences}
            onInitialPreferences={(preferences) => {
                let valuePreference = preferences
                if (typeof preferences == 'string') {
                    valuePreference = JSON.parse(preferences)
                }

                loadPreferencesDefault(valuePreference)
            }}
         >
        </Preferences>
    )
}

export default PreferenceLoad;